import { render } from "./SaleEditReviewForm.vue?vue&type=template&id=294351c9&scoped=true"
import script from "./SaleEditReviewForm.vue?vue&type=script&lang=js"
export * from "./SaleEditReviewForm.vue?vue&type=script&lang=js"

import "./SaleEditReviewForm.vue?vue&type=style&index=0&id=294351c9&lang=css&scoped=true"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294351c9"]])

export default __exports__